var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SubBarGlobal',{attrs:{"currentCrumb":_vm.currentCrumb}},[_c('PageButtons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }